import styles from './ConfidenceDot.module.css';

type ConfidenceLevel = 'high' | 'medium' | 'low';

const LEVEL_MAP: Record<ConfidenceLevel, { label: string; cls: string; dotCls: string }> = {
  high: { label: 'Confident', cls: styles.high, dotCls: styles.dotHigh },
  medium: { label: 'Review', cls: styles.medium, dotCls: styles.dotMedium },
  low: { label: 'Low', cls: styles.low, dotCls: styles.dotLow },
};

interface ConfidenceDotProps {
  level: ConfidenceLevel;
}

export function ConfidenceDot({ level }: ConfidenceDotProps) {
  const { label, cls, dotCls } = LEVEL_MAP[level] ?? LEVEL_MAP.medium;
  return (
    <span className={`${styles.root} ${cls}`}>
      <span className={`${styles.dot} ${dotCls}`} />
      {label}
    </span>
  );
}
